import { useEffect, useState, ReactNode } from "react";
import { AuthService } from "../../services/auth.service";

interface AuthGuardProps {
  children: ReactNode;
}

type AuthState = "loading" | "authorized" | "error";

export function AuthGuard({ children }: AuthGuardProps) {
  const [authState, setAuthState] = useState<AuthState>("loading");

  useEffect(() => {
    let isMounted = true;
    window.shopify?.loading(true);

    const initAuth = async () => {
      const status = await AuthService.checkInstallation();

      if (!isMounted) return;

      if (status === "installed") {
        window.shopify?.loading(false);
        setAuthState("authorized");
        return;
      }

      if (status === "needs_setup") {
        const success = await AuthService.runInitialSetup();

        if (!isMounted) return;
        window.shopify?.loading(false);

        if (success) {
          setAuthState("authorized");
        } else {
          setAuthState("error");
        }
        return;
      }

      // Fallo de red u otros errores
      if (!isMounted) return;
      window.shopify?.loading(false);
      setAuthState("error");
    };

    initAuth();

    return () => {
      isMounted = false;
    };
  }, []);

  if (authState === "loading") {
    return null; // O un spinner si lo prefieres
  }

  if (authState === "error") {
    return (
      <s-page heading="Error de Autenticación">
        <s-section accessibilityLabel="Mensaje de error de autenticación">
          <s-banner tone="critical" dismissible={false}>
            <s-text>
              No se pudo iniciar la sesión. Por favor, recarga la página o
              contacta a soporte si el problema persiste.
            </s-text>
          </s-banner>
        </s-section>
      </s-page>
    );
  }

  return <>{children}</>;
}
